/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Visa_E2_DescriptionInputs */

const en_visa_e2_description = /** @type {(inputs: Visa_E2_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The E category includes treaty-based options for qualifying trade and investment activity in the United States. Eligibility depends on nationality, ownership structure, the nature of the business activity, and the surrounding documentation.`)
};

const pt_visa_e2_description = /** @type {(inputs: Visa_E2_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A categoria E inclui opções baseadas em tratado para atividades qualificadas de comércio e investimento nos Estados Unidos. A elegibilidade depende da nacionalidade, estrutura de propriedade, natureza da atividade comercial e documentação de apoio.`)
};

const es_visa_e2_description = /** @type {(inputs: Visa_E2_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La categoría E incluye opciones basadas en tratado para actividades calificadas de comercio e inversión en los Estados Unidos. La elegibilidad depende de la nacionalidad, la estructura de propiedad, la naturaleza de la actividad comercial y la documentación de respaldo.`)
};

/**
* | output |
* | --- |
* | "The E category includes treaty-based options for qualifying trade and investment activity in the United States. Eligibility depends on nationality, ownership..." |
*
* @param {Visa_E2_DescriptionInputs} inputs
* @param {{ locale?: "en" | "pt" | "es" }} options
* @returns {LocalizedString}
*/
export const visa_e2_description = /** @type {((inputs?: Visa_E2_DescriptionInputs, options?: { locale?: "en" | "pt" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Visa_E2_DescriptionInputs, { locale?: "en" | "pt" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt") return pt_visa_e2_description(inputs)
	if (locale === "es") return es_visa_e2_description(inputs)
	return en_visa_e2_description(inputs)
});